import { TEditedData, TPaymentModel } from 'modules/settings/models';
import API from 'services/api';

export const createContractPaymentModels = ({
  payload,
}: {
  payload: TPaymentModel | TEditedData;
}) => API.post('/api/payment-models', payload);
